import { createSlice } from "@reduxjs/toolkit";
import {
  fetchAccountBalance,
  fetchBankAccountsBySearch,
  fetchCashAccountsBySearch,
} from "./AccountBalanceThunk";

const initialState = {
  list: [],
  loading: false,
  cashAccounts: [],
  cashAccountsLoading: false,
  bankAccounts: [],
  bankAccountsLoading: false,
  totals: { opening: 0, debit: 0, credit: 0, balance: 0 },
  filters: {
    filterType: "Cash & Bank",
    accountId: null,
    fromDate: null,
    toDate: null,
  },
};

const accountBalanceSlice = createSlice({
  name: "accountBalance",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAccountBalance.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAccountBalance.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.list;
        state.totals = action.payload.totals;
      })
      .addCase(fetchAccountBalance.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchBankAccountsBySearch.pending, (state) => {
        state.bankAccountsLoading = true;
      })
      .addCase(fetchBankAccountsBySearch.fulfilled, (state, action) => {
        state.bankAccountsLoading = false;
        state.bankAccounts = action.payload;
      })
      .addCase(fetchBankAccountsBySearch.rejected, (state) => {
        state.bankAccountsLoading = false;
        state.bankAccounts = [];
      })
      .addCase(fetchCashAccountsBySearch.pending, (state) => {
        state.cashAccountsLoading = true;
      })
      .addCase(fetchCashAccountsBySearch.fulfilled, (state, action) => {
        state.cashAccountsLoading = false;
        state.cashAccounts = action.payload;
      })
      .addCase(fetchCashAccountsBySearch.rejected, (state) => {
        state.cashAccountsLoading = false;
        state.cashAccounts = [];
      });
  },
});

export const { setFilters } = accountBalanceSlice.actions;
export default accountBalanceSlice.reducer;
